<!-- Image -->

<ion-img [src]="image" [alt]="alt" width="100%" height="100%" [class.radius]="radius" *ngIf="image != ''; else loading;" onerror="this.style.display='none'"></ion-img>

<!-- Loading -->

<ng-template #loading>
  <ion-skeleton-text animated></ion-skeleton-text>
</ng-template>